import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=fdce275a&scoped=true&"
import script from "./DashboardPage.vue?vue&type=script&lang=js&"
export * from "./DashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=fdce275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdce275a",
  null
  
)

export default component.exports